import React from "react";
import PropTypes from "prop-types";
import BondRetrievalBillingInformationBase from "./BondRetrievalBillingInformationBase";
import { RETRIEVE_GLOBAL_DATA_ROLE_DISABLED } from "./bondRetrieveSharedPropTypes";
import { getBillingRetrievalConfig } from "../billingRetrievalConfig";

const BondRetrievalBillingInformation = ({
  bondType,
  GoogleAutoComplete,
  LabeledCreatableSelect,
  ...props
}) => (
  <BondRetrievalBillingInformationBase
    cfg={getBillingRetrievalConfig(bondType)}
    GoogleAutoComplete={GoogleAutoComplete}
    LabeledCreatableSelect={LabeledCreatableSelect}
    {...props}
  />
);

BondRetrievalBillingInformation.propTypes = {
  ...RETRIEVE_GLOBAL_DATA_ROLE_DISABLED,
  bondType: PropTypes.oneOf(["guardianship", "va", "trustee", "probate"]).isRequired,
  GoogleAutoComplete: PropTypes.elementType.isRequired,
  LabeledCreatableSelect: PropTypes.elementType.isRequired,
};

export default BondRetrievalBillingInformation;
